export default "__VITE_ASSET__B23Rlefv__"